<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>Keycloak設定値</h5>
      </div>
      <div class="col-3">
        <button id="createUserBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>      
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:50px">#</th>
              <th scope="col">項目名称</th>
              <th scope="col">設定値</th>
              <th scope="col" style="width:100px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(keycloak, index) in keycloaks" v-bind:key="keycloak.id">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ keycloak.keycloakKey }}</td>
              <td>{{ keycloak.keycloakValue }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="modify(keycloak.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  src: {
    authority
  },
  data: function(){
    return {
      keycloaks: [],
      message: '',
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search()
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/keycloak/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/keycloak/modify/'+id))
    },
    search() {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var code = this.$store.getters.hospital.code
        
        axios.get("/api/keycloak/management/list/" + code,{
          headers: this.headers(accessToken)
        }).then(response => {
          this.keycloaks = response.data.data.keycloaks
          
        }).catch(err => {
          this.message = err.message
        })

      } else {
       this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createUserBtn {
  float:right;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
#sort-select{
  width: 70%;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.online {
  fill: #FF4E00
}
.offline {
  fill: #D9D9D9
}
</style>